import { Tooltip } from 'antd';
import React, { useState } from 'react';
import ContactLists from './contactlists';
import styles from "./scss/leftsidebar.module.scss";

import { initialStateModel, leftsideChats } from "../../../models/model";
import { useSelector } from 'react-redux';

type setdefaultContactsProps = {
  defaultContacts: any
  updateChatIndexData: any;
  chats: any;
}
export default function Favouritechats({ defaultContacts, chats, updateChatIndexData }: setdefaultContactsProps) {

  const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer);
  let { isPinchatLoader } = contactList;
  const [isOpen, setIsOpen] = useState(false);
  const toggleArrow = (e: any) => {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className={`${styles.pinnedchatlayer} ${"pinnedleft"}`}>
        {/* <Menu
          onOpenChange={toggleArrow}
          defaultSelectedKeys={['1']}
          mode="inline"
          className="pinnedmain"
          tabIndex={undefined}
        > */}
        {/* <SubMenu key="sub2" className='pinnchats favIcon' title="Favourite Chat" 
            icon={<Tooltip placement="top" title={isOpen ? "Click to collapse favourite chats": "Click to show favourite chats"}>

              <span className="iconToggle" ></span></Tooltip>}> */}
        {/* {defaultContacts?.favouriteContacts && Array.isArray(defaultContacts?.favouriteContacts) && defaultContacts?.favouriteContacts.length > 0 &&
          <div className={styles.colpsHeader} onClick={toggleArrow} >
            <span className={isOpen ? `${styles.favchatIcn} ${styles.favchatIcnClose}` : styles.favchatIcn} ></span>
            <span className={styles.colpsTitle}>Favourite Chat</span>
            <Tooltip mouseEnterDelay={0.5} placement="top" title={isOpen ? "Click to collapse favourite chats" : "Click to show favourite chats"} className='cusTooltip'
              overlayClassName='customTooltip'>
            </Tooltip>
          </div>} */}
        {/* {isOpen && Array.isArray(defaultContacts?.favouriteContacts) && defaultContacts?.favouriteContacts?.length > 0 && (
          <div className={`${styles.rightbarbottom} ${"scrollerhover"} fadeIn`}>
            <ContactLists chats={chats} searchContactList={defaultContacts?.favouriteContacts} isSearch={defaultContacts.isSearch}
              contactList={defaultContacts?.favouriteContacts} isLoader={isPinchatLoader}

              updateChatIndex={updateChatIndexData}
              searchText={defaultContacts.searchText} pinnedList={defaultContacts}></ContactLists>
          </div>

        )
        } */}
        {/* </SubMenu>
        </Menu> */}
      </div>
    </>
  );
}
